import { createLogger } from "@/infrastructure/services/logger";

const dynamicValueRegex = /\{(\w+)\}/g;

const extractDynamicValues = (template: string): string[] => {
  return Array.from(template.matchAll(dynamicValueRegex), match => match[1]);
};

export const constructNote = (template: string, values: string[]) => {
  const logger = createLogger("BackupRequestUtils");
  const argNames = extractDynamicValues(template);

  if (argNames.length > values.length) {
    logger.error("The number of arguments is greater than the number of values", argNames, values);
  }

  // Build a lookup map from name → value
  const nameToValue: Record<string, string> = {};
  for (let index = 0; index < argNames.length; index++) {
    const name = argNames[index];
    nameToValue[name] = values[index] ?? `{${name}}`;
  }

  return template.replaceAll(dynamicValueRegex, (match, key) => {
    return key in nameToValue ? nameToValue[key] : match;
  });
};
